import {formatPhoneNumber} from "../../utils/phoneHandlers";
import PhoneLink from "../PhoneLink";
import React from "react";
import {Link} from "react-router-dom";
import {PATHS} from "../../route-dictionary";
import {ACTIONS, hasGlobalPermission} from "../../utils/user-access";

export const getMemberText = (item) => {
  const members = <>{item.first_name || item.email} {item.last_name}{" "}</>;

  return {
    jsx:
      <>
        {
          hasGlobalPermission(ACTIONS.VIEW_MEMBER_DETAILS) ?
            <Link to={PATHS.MEMBERS.getDetailsIdPath(item.id)}>
              {members}
            </Link> :
            members
        }
        {
          item.phone &&
          <>
            (<PhoneLink>{formatPhoneNumber(item.phone)}</PhoneLink>)
          </>
        }
      </>,
    toString: () =>
      `${item.first_name || item.email} ${item.last_name ? item.last_name : ""} ${item.phone ? `(${formatPhoneNumber(item.phone)})` : ""}`
  };
};

export const getTelegramChatText = (item) => (
  {
    jsx: item.name,
    toString: () => item.name
  });

export const getPhoneNumberText = (item) => (
  {
    jsx: <PhoneLink>{formatPhoneNumber(item)}</PhoneLink>,
    toString: () => formatPhoneNumber(item)
  });

export const getRuleIndex = (rule) => typeof rule._index === "number" ? rule._index : rule.id;